<script setup lang="ts">
import SkeletonBox from '@/components/SkeletonBox.vue';

</script>

<template>
    <div class="showcase-item">
        <header class="showcase-item__img-container">
            <SkeletonBox height="100%" width="100%" />
        </header>
        <section class="showcase-item__section showcase-item__section--long">
            <h3 class="showcase-item__heading showcase-item__heading--no-mb">
                <SkeletonBox height="2rem" width="30%" />
                <SkeletonBox height="4rem" />
            </h3>
        </section>
        <section class="showcase-item__section">
            <SkeletonBox height="3rem" />
            <SkeletonBox height="3rem" width="80%" />
            <SkeletonBox height="3rem" width="40%" />
        </section>
        <section class="showcase-item__section">
            <SkeletonBox height="5rem" />
        </section>
    </div>
</template>
